import { useState, useEffect } from 'react';

// Cuenta regresiva hasta el inicio de venta (sales_start_at, instante ISO).
// Devuelve { active } = true mientras falte para abrir la venta, con los
// componentes d/h/m/s. Al llegar la hora, active pasa a false y la UI muestra
// los lotes / botón de compra. Compara instantes absolutos (tz-safe).
export function usePresale(at) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!at) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [at]);
  if (!at) return { active: false };
  const target = new Date(at).getTime();
  if (isNaN(target)) return { active: false };
  const diff = target - now;
  if (diff <= 0) return { active: false };
  return {
    active: true,
    at,
    d: Math.floor(diff / 86400000),
    h: Math.floor(diff / 3600000) % 24,
    m: Math.floor(diff / 60000) % 60,
    s: Math.floor(diff / 1000) % 60,
  };
}

// Formatea el instante de apertura para mostrar "Abre el ...".
export function fmtPresale(at) {
  if (!at) return '';
  try {
    return new Date(at).toLocaleString('es-AR', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' });
  } catch { return ''; }
}
